var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9997-.0003c.361 0 .653.292.653.653 0 .36-.292.652-.653.652h-3.105c-.325 0-.59.264-.59.589v6.212c0 .325.265.59.59.59h6.211c.325 0 .59-.265.59-.59v-3.106c0-.36.292-.652.652-.652.36 0 .652.292.652.652v3.106c0 1.044-.849 1.894-1.894 1.894h-6.211c-1.045 0-1.895-.85-1.895-1.894v-6.212c0-1.044.85-1.894 1.895-1.894zm4.3475.0001c.085 0 .17.018.249.05.161.067.288.194.353.353.033.08.051.165.051.25v1.716c0 .36-.292.652-.653.652-.36 0-.652-.292-.652-.652v-.142l-3.234 3.234c-.127.128-.294.192-.461.192-.167 0-.334-.064-.461-.192-.128-.127-.192-.294-.192-.461 0-.167.064-.333.192-.461l3.234-3.235h-.141c-.361 0-.653-.292-.653-.651 0-.361.292-.653.653-.653z",
    fill: "currentcolor",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/link.3ce0ec5c.svg";
export { ForwardRef as ReactComponent };